import { PropTypes } from "base/react-libs";
import TaskCountTable from "./task-count-table";

const TaskCount = ({ title, subTitle, showIcon, icon, data }) => {
  return (
    <div className="task-counter-content">
      <div className="task-card-padding">
        <div className="task-counter-home--title">{title}</div>
        <div className="task-counter-home--subtitle">{subTitle}</div>
        {showIcon ? (
          <table className="task-counter-card--details--icon">
            <tbody className="task-counter-check-icon-tb">
              <tr>
                <td>
                  <img src={icon} alt="icon" style={{ cursor: "pointer" }} />
                </td>
              </tr>
            </tbody>
          </table>
        ) : (
          <TaskCountTable data={data} />
        )}
      </div>
    </div>
  );
};

TaskCount.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  showIcon: PropTypes.bool,
  icon: PropTypes.string,
  data: PropTypes.object,
};

export default TaskCount;
